import React from "react";
import { lastWeekPeriod, periodLabel, yesterdayPeriod } from "../../utils/billingPeriods.js";

const BUTTON = "inline-flex h-6 items-center rounded-[4px] border px-2 text-[11px] font-bold disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-400 disabled:opacity-100 disabled:shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30";
const SECONDARY = `${BUTTON} border-slate-300 bg-white text-slate-700 hover:border-slate-400 hover:bg-slate-50 hover:text-slate-900`;
const PRIMARY = `${BUTTON} border-accent bg-accent text-white hover:border-accent-strong hover:bg-accent-strong`;
const DATE = "h-6 rounded-[4px] border border-slate-300 bg-white px-1.5 py-0 text-[11px] text-slate-800";

/** Jours couverts par un relevé : choix rapides ou deux dates. Appliquer reprend les prestations de la nouvelle période. */
export default function InvoicePeriodEditor({ from, to, disabled = false, onApply, today }) {
  const [open, setOpen] = React.useState(false);
  const [draft, setDraft] = React.useState({ from, to });
  if (!open) {
    return <button type="button" className={`${SECONDARY} ml-2`} disabled={disabled}
      onClick={() => { setDraft({ from, to }); setOpen(true); }}>Modifier la période</button>;
  }
  const choices = [["Semaine dernière", lastWeekPeriod(today)], ["Hier", yesterdayPeriod(today)]];
  const valid = Boolean(draft.from && draft.to && draft.from <= draft.to);
  const changed = draft.from !== from || draft.to !== to;
  return <div className="mt-1 flex flex-wrap items-center gap-1.5">
    {choices.map(([label, period]) => <button key={label} type="button" className={SECONDARY} disabled={disabled}
      aria-pressed={draft.from === period.from && draft.to === period.to} onClick={() => setDraft(period)}>
      {label} · {periodLabel(period.from, period.to)}</button>)}
    <input type="date" aria-label="Début de la période" className={DATE} value={draft.from || ""} disabled={disabled}
      onChange={(event) => setDraft((current) => ({ ...current, from: event.target.value }))} />
    <span aria-hidden="true" className="text-slate-500">→</span>
    <input type="date" aria-label="Fin de la période" className={DATE} value={draft.to || ""} disabled={disabled}
      onChange={(event) => setDraft((current) => ({ ...current, to: event.target.value }))} />
    <button type="button" className={PRIMARY} disabled={disabled || !valid || !changed}
      onClick={async () => { if (await onApply?.(draft) !== null) setOpen(false); }}>Appliquer</button>
    <button type="button" className={SECONDARY} disabled={disabled} onClick={() => setOpen(false)}>Annuler</button>
    {!valid && draft.from && draft.to ? <span className="text-[11px] font-bold text-[#c5524a]">La fin doit suivre le début.</span> : null}
  </div>;
}
